import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./viewerForm.data.form";
import {
  InputText,
  InputSelect,
  InputFile,
  InputTextarea,
} from "@de-prado-dev/react-component-library";

import {
  FormContainer,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  FormBody,
  FormSection,
  SectionLabel,
  ButtonsContainer,
  CancelButton,
  ActionButton,
} from "./viewerForm.styled";
import { useDispatch } from "react-redux";
import { hide } from "redux-modal";

const CourseForm = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { handleSubmit, onBack, edit } = props;

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  return (
    <>
      <FormContainer>
        <Header>
          <HeaderTitle>{t("forms.viewer.titleNew")}</HeaderTitle>
          <HeaderSubtitle>{t("forms.viewer.subtitle")}</HeaderSubtitle>
        </Header>
        <FormBody>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <FormSection>
              <SectionLabel mandatory>
                {t("forms.viewer.labels.name")}
              </SectionLabel>
              <Field
                id="name"
                className="form-control"
                name="name"
                placeholder=""
                component={InputText}
                fieldType="text"
                mandatory
              />
            </FormSection>
            <FormSection>
              <SectionLabel mandatory>
                {t("forms.viewer.labels.nif")}
              </SectionLabel>
              <Field
                id="nif"
                className="form-control"
                name="nif"
                placeholder=""
                component={InputText}
                fieldType="text"
                mandatory
              />
            </FormSection>

            <ButtonsContainer>
              <CancelButton
                type="button"
                onClick={() => handlerClosePopup("ModalForm")}
              >
                {t("forms.form.buttons.cancel")}
              </CancelButton>
              <ActionButton type="submit">
                {t("forms.form.buttons.save")}
              </ActionButton>
            </ButtonsContainer>
          </form>
        </FormBody>
      </FormContainer>
    </>
  );
};

CourseForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const CourseFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "CourseForm",
})(CourseForm);

export default CourseFormF;
